import { useState, useEffect } from "react";
import { ChevronUp } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

interface EmailPopupTriggerProps {
  onTrigger: () => void;
}

export function EmailPopupTrigger({ onTrigger }: EmailPopupTriggerProps) {
  const [isVisible, setIsVisible] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    const emailPopupShown = localStorage.getItem("emailPopupShown") === "true";
    const hasAccount = !!user;

    const shouldShow = !hasAccount && !emailPopupShown;
    setIsVisible(shouldShow);
  }, [user]);

  if (!isVisible) return null;

  return (
    <button
      onClick={onTrigger}
      className="fixed bottom-0 left-[10%] z-50 bg-primary text-primary-foreground py-2.5 px-4 rounded-t-lg shadow-md cursor-pointer hover:bg-primary/90 transition-all duration-300 animate-in slide-in-from-bottom flex items-center gap-1.5"
      aria-label="Save Up To 10% - Click to open signup"
    >
      <ChevronUp className="h-4 w-4" />
      <span className="font-semibold text-sm">Save Up To 10%</span>
    </button>
  );
}
